import fs from 'fs-extra'
import { DetectResult, detect } from 'package-manager-detector'
import path from 'path'

//Detects the package manager based on the lock files i.e. yarn.lock,pnpm-lock.yaml,package-lock.json, bun.lockb
export const getPackageManager = async (projectPath: string): Promise<DetectResult> => {
  const resolvedPath = path.resolve(projectPath)

  if (!fs.existsSync(resolvedPath)) {
    throw new Error(`The path "${resolvedPath}" does not exist.`)
  }

  return await detect({ cwd: resolvedPath })
}

//Based on the detected package manager, return the package runner
export const getPackageRunner = async (projectPath: string) => {
  const packageManager = await getPackageManager(projectPath)

  if (!packageManager) return null

  switch (packageManager.name) {
    case 'npm':
      return 'npx'
    case 'pnpm':
      return 'pnpm dlx'
    case 'bun':
      return 'bunx'
    case 'yarn':
      return 'yarn dlx'
    default:
      return null
  }
}

export const getDependencyInstaller = async (projectPath: string) => {
  const packageManager = await getPackageManager(projectPath)

  if (!packageManager) return null

  switch (packageManager.name) {
    case 'npm':
      return 'install'
    case 'pnpm':
      return 'install'
    case 'bun':
      return 'add'
    case 'yarn':
      return 'add'
    default:
      return null
  }
}
